import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CMClubSiteConfigListResponse, CMSiteListResponse, RptContractSummaryRequest, RptContractSummaryResp, RptContractSummaryResponse, TeamCodeChangeRes } from '../models/cm-club-service.model';
import { delayedRetryHttp } from './shared/delayedRetry';

import { UtilityService } from './shared/utility.service';

@Injectable({
    providedIn: 'root'
})
export class CMClubService {
    private baseUrl: string;
    private api: string = 'api/CMClub';
    clubId = new BehaviorSubject<number>(0)
    curClubId = this.clubId.asObservable()
    site = new BehaviorSubject<{}>(null)
    curSite = this.site.asObservable()
    baseUrlAI: string;
    constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
        this.baseUrl = _baseUrl + this.api;
    }
    async clubSiteConfigSearch(encryptedUser: string, id: number, clubID: number, teamCode: number, clpcompanyID: number): Promise<CMClubSiteConfigListResponse | void> {
        const a = await this.httpClient
            .get<CMClubSiteConfigListResponse>(`${this.baseUrl}/CMClubSiteConfig_Search/${clpcompanyID}/${teamCode}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMClubService", "clubSiteConfigSearch"); });
        return a;
    }

    async siteSearch(encryptedUser: string, siteID: number, clubID: number, class1Code: number, clpcompanyID: number): Promise<CMSiteListResponse | void> {
        const a = await this.httpClient
            .get<CMSiteListResponse>(`${this.baseUrl}/CMSite_Search/${siteID}/${clpcompanyID}/${class1Code}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMClubService", "siteSearch"); });
        return a;
    }
    
    async rptContractSummary_GetFilters(encryptedUser: string, clpCompanyID, clpUserID : number): Promise<RptContractSummaryResponse | void> {
        const a = await this.httpClient
            .get<RptContractSummaryResponse>(`${this.baseUrl}/RptContractSummary_GetFilters/${clpCompanyID}/${clpUserID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMClubService", "rptContractSummary_GetFilters"); });
        return a;
    }

    async rptContractSummary_Load(encryptedUser: string, rptContractSummaryRequest: RptContractSummaryRequest): Promise<RptContractSummaryResp | void> {
        const a = await this.httpClient
            .post<RptContractSummaryResp>(`${this.baseUrl}/RptContractSummary_Load`, rptContractSummaryRequest, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMClubService", "RptContractSummary_Load"); });
        return a;
    }

    async rptContractSummary_TeamCodeChange(encryptedUser: string, clpCompanyID : number, teamCode : number): Promise<TeamCodeChangeRes | void> {
        const a = await this.httpClient
            .get<TeamCodeChangeRes>(`${this.baseUrl}/RptContractSummary_TeamCodeChange/${clpCompanyID}/${teamCode}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMClubService", "rptContractSummary_TeamCodeChange"); });
        return a;
    }

    async rptContractSummarydExport(encryptedUser: string, rptContractSummaryRequest: RptContractSummaryRequest): Promise<RptContractSummaryResp | void> {
        const a = await this.httpClient
            .post<RptContractSummaryResp>(`${this.baseUrl}/RptContractSummarydExport`, rptContractSummaryRequest, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMClubService", "rptContractSummarydExport"); });
        return a;
    }
}
